import * as THREE from "three";

export function textTexture({ text, w = 512, h = 128, bg = "#000000", color = "#ffffff", font = "bold 64px Arial", border = null }) {
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  const ctx = c.getContext("2d");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, w, h);
  if (border) {
    ctx.strokeStyle = border;
    ctx.lineWidth = 10;
    ctx.strokeRect(5, 5, w - 10, h - 10);
  }
  ctx.fillStyle = color;
  ctx.font = font;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(text, w / 2, h / 2);
  const tex = new THREE.CanvasTexture(c);
  tex.anisotropy = 4;
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}

export function crossTexture() {
  const c = document.createElement("canvas");
  c.width = 64; c.height = 64;
  const ctx = c.getContext("2d");
  ctx.clearRect(0, 0, 64, 64);
  ctx.strokeStyle = "#0a3d1f";
  ctx.lineWidth = 8;
  ctx.beginPath();
  ctx.moveTo(32, 6); ctx.lineTo(32, 58);
  ctx.moveTo(6, 32); ctx.lineTo(58, 32);
  ctx.stroke();
  const tex = new THREE.CanvasTexture(c);
  return tex;
}

export function dangerTexture() {
  const c = document.createElement("canvas");
  c.width = 256; c.height = 256;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#8c1d18";
  ctx.fillRect(0, 0, 256, 256);
  ctx.fillStyle = "#eab308";
  ctx.fillRect(0, 88, 256, 80);
  ctx.fillStyle = "#000";
  for (let i = 0; i < 8; i++) {
    ctx.save();
    ctx.translate(i * 36 - 8, 88);
    ctx.transform(1, 0, -0.4, 1, 0, 0);
    ctx.fillRect(0, 0, 16, 12);
    ctx.restore();
    ctx.save();
    ctx.translate(i * 36 - 8, 156);
    ctx.transform(1, 0, 0.4, 1, 0, 0);
    ctx.fillRect(0, 0, 16, 12);
    ctx.restore();
  }
  ctx.fillStyle = "#111";
  ctx.font = "900 44px Arial";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("DANGER", 128, 128);
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}

export function monitorTexture(line1 = "REC", line2 = "4K · 23.976") {
  const c = document.createElement("canvas");
  c.width = 320; c.height = 200;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#050a08";
  ctx.fillRect(0, 0, 320, 200);
  ctx.fillStyle = "#123326";
  for (let i = 0; i < 12; i++) ctx.fillRect(0, i * 18, 320, 8);
  ctx.fillStyle = "#ff3333";
  ctx.beginPath(); ctx.arc(36, 34, 10, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#e8f5e9";
  ctx.font = "bold 30px monospace";
  ctx.textAlign = "left";
  ctx.fillText(line1, 58, 44);
  ctx.font = "20px monospace";
  ctx.fillStyle = "#7dd3a8";
  ctx.fillText(line2, 24, 180);
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}

export function boardTexture() {
  const c = document.createElement("canvas");
  c.width = 512; c.height = 384;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#8a6b45";
  ctx.fillRect(0, 0, 512, 384);
  const papers = [
    [30, 40, 140, 100, "#e8e2d0"], [200, 30, 120, 140, "#f2ecd8"], [360, 50, 120, 90, "#e5dec8"],
    [50, 180, 130, 150, "#efe9d6"], [230, 200, 110, 120, "#e8e2d0"], [380, 170, 100, 160, "#f5efdc"],
  ];
  papers.forEach(([x, y, w, h, col], idx) => {
    ctx.save();
    ctx.translate(x + w / 2, y + h / 2);
    ctx.rotate((idx % 2 ? -1 : 1) * 0.06);
    ctx.fillStyle = col;
    ctx.fillRect(-w / 2, -h / 2, w, h);
    ctx.fillStyle = "#333";
    ctx.font = "900 20px Georgia";
    ctx.textAlign = "left";
    ctx.fillText(idx % 2 ? "LA STAMPA" : "CINEMA", -w / 2 + 10, -h / 2 + 26);
    ctx.fillStyle = "#777";
    for (let l = 0; l < 5; l++) ctx.fillRect(-w / 2 + 10, -h / 2 + 42 + l * 14, w - 20 - (l * 13) % 40, 4);
    if (idx % 2 === 0) {
      ctx.fillStyle = "#2b3a55";
      ctx.fillRect(-w / 2 + 12, h / 2 - 58, 46, 46);
      ctx.fillStyle = "#c9a186";
      ctx.beginPath(); ctx.arc(-w / 2 + 35, h / 2 - 40, 10, 0, Math.PI * 2); ctx.fill();
      ctx.fillRect(-w / 2 + 22, h / 2 - 30, 26, 20);
    }
    ctx.fillStyle = "#b91c1c";
    ctx.beginPath(); ctx.arc(0, -h / 2 + 6, 5, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
  });
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}
